import { render, staticRenderFns } from "./IconCloudComputing.vue?vue&type=template&id=60a1e448&"
import script from "./IconCloudComputing.vue?vue&type=script&lang=js&"
export * from "./IconCloudComputing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports